(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["appointment-form"] && !Shopify.designMode) return;
  try {
    
  function submitToWhatsApp(event) {
    event.preventDefault();
    
    const form = event.target;
    const formData = new FormData(form);
    
    const name = formData.get('name');
    const email = formData.get('email');
    const phone = formData.get('phone');
    const country = formData.get('country') || 'PK';
    const date = formData.get('date');
    const time = formData.get('time');
    const purpose = formData.get('purpose');
    
    // Format date
    const dateObj = new Date(date);
    const formattedDate = dateObj.toLocaleDateString('en-US', { 
      weekday: 'long', 
      year: 'numeric', 
      month: 'long', 
      day: 'numeric' 
    });
    
    // Get country name
    const countryNames = {
      'PK': 'Pakistan',
      'US': 'United States',
      'GB': 'United Kingdom',
      'CA': 'Canada',
      'AU': 'Australia',
      'FR': 'France',
      'DE': 'Germany',
      'IT': 'Italy',
      'ES': 'Spain',
      'AE': 'United Arab Emirates',
      'SA': 'Saudi Arabia',
      'IN': 'India',
      'SG': 'Singapore',
      'HK': 'Hong Kong',
      'JP': 'Japan',
      'CN': 'China'
    };
    const countryName = countryNames[country] || country;
    
    // Create WhatsApp message
    const message = `*Appointment Request*

*Name:* ${name}
*Email:* ${email}
*Phone:* ${phone}
*Country:* ${countryName}
*Preferred Date:* ${formattedDate}
*Preferred Time:* ${time}
*Purpose:* ${purpose}`;
    
    // Get WhatsApp number from form data attribute
    const whatsappNumber = form.getAttribute('data-whatsapp-number') || '';
    
    // Encode message for URL
    const encodedMessage = encodeURIComponent(message);
    
    // Open WhatsApp
    const whatsappUrl = `https://wa.me/${whatsappNumber}?text=${encodedMessage}`;
    window.open(whatsappUrl, '_blank');
    
    // Show success message
    const successHTML = `
      <div class="appointment-form__success">
        <div class="appointment-form__success-icon">
          <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="24" cy="24" r="23" stroke="#000" stroke-width="2"/>
            <path d="M16 24L22 30L32 18" stroke="#000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
        <h2 class="appointment-form__success-title">Opening WhatsApp...</h2>
        <p class="appointment-form__success-message">Your appointment request has been prepared. Please send the message in WhatsApp to complete your request.</p>
      </div>
    `;
    
    form.innerHTML = successHTML;
    
    return false;
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["booking-form"] && !Shopify.designMode) return;
  try {
    
  function submitBookingToWhatsApp(event) {
    event.preventDefault();
    
    const form = event.target;
    const formData = new FormData(form);
    
    const name = formData.get('name');
    const email = formData.get('email');
    const phone = formData.get('phone');
    const service = formData.get('service');
    const date = formData.get('date');
    const time = formData.get('time');
    const location = formData.get('location');
    const message = formData.get('message');
    
    // Format date
    const dateObj = new Date(date);
    const formattedDate = dateObj.toLocaleDateString('en-US', { 
      weekday: 'long', 
      year: 'numeric', 
      month: 'long', 
      day: 'numeric' 
    });
    
    // Get service label
    const serviceLabels = {
      'consultation': 'Design Consultation',
      'sizing': 'Ring Sizing',
      'cleaning': 'Professional Cleaning',
      'repair': 'Repair Service',
      'custom': 'Custom Design',
      'viewing': 'Collection Viewing',
      'other': 'Other'
    };
    const serviceLabel = serviceLabels[service] || service;
    
    // Get location label
    const locationLabels = {
      'boutique': 'Main Boutique',
      'online': 'Online Consultation',
      'home': 'Home Visit'
    };
    const locationLabel = location ? (locationLabels[location] || location) : 'Not specified';
    
    // Create WhatsApp message
    const whatsappMessage = `*Booking Request*

*Name:* ${name}
*Email:* ${email}
*Phone:* ${phone}
*Service Type:* ${serviceLabel}
*Preferred Date:* ${formattedDate}
*Preferred Time:* ${time}
*Preferred Location:* ${locationLabel}
*Additional Details:* ${message}`;
    
    // Get WhatsApp number from form data attribute
    const whatsappNumber = form.getAttribute('data-whatsapp-number') || '';
    
    if (!whatsappNumber) {
      console.warn('WhatsApp number is not configured for booking form.');
      return false;
    }
    
    // Encode message for URL
    const encodedMessage = encodeURIComponent(whatsappMessage);
    
    // Open WhatsApp
    const whatsappUrl = `https://wa.me/${whatsappNumber}?text=${encodedMessage}`;
    window.open(whatsappUrl, '_blank');
    
    // Show success message
    const successHTML = `
      <div class="booking-form__success">
        <div class="booking-form__success-icon">
          <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="24" cy="24" r="23" stroke="#000" stroke-width="2"/>
            <path d="M16 24L22 30L32 18" stroke="#000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
        <h2 class="booking-form__success-title">Opening WhatsApp...</h2>
        <p class="booking-form__success-message">Your booking request has been prepared. Please send the message in WhatsApp to complete your request.</p>
      </div>
    `;
    
    form.innerHTML = successHTML;
    
    return false;
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const cartForm = document.querySelector('form[action*="/cart"]');
    const removeButtons = document.querySelectorAll('[data-remove-item]');
    const summaryValue = document.querySelector('.cart-page__summary-row--subtotal .cart-page__summary-value');
    const taxValue = document.querySelector('.cart-page__summary-row--tax .cart-page__summary-value');
    const cartRoot = document.querySelector('.cart-page');
    const updateErrorMessage =
      cartRoot?.getAttribute('data-cart-update-error') || 'Failed to update cart. Please refresh and try again.';

    // Disable cart toast notification system globally
    function showToast(message) {
      return;
    }

    // Debounce function for cart updates
    let updateTimeout;
    function debounce(func, wait) {
      return function (...args) {
        clearTimeout(updateTimeout);
        updateTimeout = setTimeout(() => func.apply(this, args), wait);
      };
    }

    // Format money based on cart currency
    function formatMoney(cents) {
      try {
        // Try to get currency from existing price display or use default
        let currency = 'PKR';
        const existingPrice = document.querySelector('[data-item-total]');
        if (existingPrice) {
          const priceText = existingPrice.textContent.trim();
          // Try to extract currency code from existing price (e.g., "PKR" from "Rs.40,000.00")
          if (priceText.includes('Rs.') || priceText.includes('PKR')) {
            currency = 'PKR';
          } else {
            const currencyMatch = priceText.match(/\b([A-Z]{3})\b/);
            if (currencyMatch) {
              currency = currencyMatch[1];
            }
          }
        }

        // Fallback to Shopify currency if available
        if (typeof Shopify !== 'undefined' && Shopify.currency && Shopify.currency.active) {
          currency = Shopify.currency.active;
        }

        const amount = cents / 100;
        
        // Special handling for PKR
        if (currency === 'PKR') {
          return 'PKR ' + amount.toLocaleString('en-PK', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        }
        
        return new Intl.NumberFormat('en-US', {
          style: 'currency',
          currency: currency,
        }).format(amount);
      } catch (error) {
        // Fallback formatting if Intl.NumberFormat fails - use PKR format
        const amount = (cents / 100).toFixed(2);
        return 'PKR ' + parseFloat(amount).toLocaleString('en-PK', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      }
    }

    // Fetch current cart state from server
    function fetchCartState() {
      return fetch('/cart.js', {
        headers: {
          Accept: 'application/json',
        },
      })
        .then(function (response) {
          if (!response.ok) {
            throw new Error('Failed to fetch cart');
          }
          return response.json();
        })
        .catch(function (error) {
          console.warn('Could not fetch cart state:', error);
          return null;
        });
    }

    // Update cart summary display
    function updateCartSummaryDisplay(totalPrice, taxPrice) {
      if (!totalPrice && totalPrice !== 0) return;

      const newTotalText = formatMoney(totalPrice);
      
      // Update subtotal value in summary
      if (summaryValue) {
        summaryValue.textContent = newTotalText;
      }
      
      // Update tax value in summary
      if (taxValue && taxPrice !== undefined) {
        const newTaxText = formatMoney(taxPrice || 0);
        taxValue.textContent = newTaxText;
      }
    }

    // Update cart via AJAX - for removing items
    function removeCartItem(lineIndex, callback) {
      const url = `/cart/change.js`;
      const formData = new URLSearchParams();
      formData.append('line', lineIndex);
      formData.append('quantity', '0');

      fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formData.toString(),
      })
        .then(function (response) {
          if (!response.ok) {
            throw new Error('Cart update failed: ' + response.status);
          }
          return response.json();
        })
        .then(function (cart) {
          // Update summary
          if (cart && cart.total_price !== undefined) {
            updateCartSummaryDisplay(cart.total_price, cart.total_tax || cart.tax_price || 0);
          }

          // Trigger cart update event
          if (window.dispatchEvent) {
            window.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
            window.dispatchEvent(new CustomEvent('cart:refresh'));
          }

          if (callback) callback(cart);
        })
        .catch(function (error) {
          console.error('Error removing cart item:', error);
          showToast(updateErrorMessage);
          if (callback) callback(null);
        });
    }

    // Fetch cart state and update summary
    fetchCartState()
      .then(function (cart) {
        if (cart && cart.total_price !== undefined) {
          updateCartSummaryDisplay(cart.total_price, cart.total_tax || cart.tax_price || 0);
        }
      })
      .catch(function () {
        console.warn('Could not fetch cart state');
      });

    // Ensure wishlist API is available
    function ensureWishlistApi() {
      const WISHLIST_STORAGE_KEY = 'wishlist';
      window.ZaivorWishlist = window.ZaivorWishlist || {};
      const wishlistApi = window.ZaivorWishlist;

      if (!wishlistApi.getWishlist) {
        wishlistApi.normalizeItem = function(item) {
          if (typeof item === 'string' || typeof item === 'number') {
            return { id: item.toString() };
          }
          if (item && typeof item === 'object') {
            const normalizedId = item.id ? item.id.toString() : '';
            if (!normalizedId) return null;
            const normalizedVariantId = item.variant_id || item.variantId || item.variant || '';
            return {
              id: normalizedId,
              variant_id: normalizedVariantId ? normalizedVariantId.toString() : '',
              title: item.title || '',
              handle: item.handle || '',
              url: item.url || '',
              sku: item.sku || '',
              price: item.price || '',
              price_formatted: item.price_formatted || '',
              compare_price: item.compare_price || '',
              compare_price_formatted: item.compare_price_formatted || '',
              image: item.image || ''
            };
          }
          return null;
        };

        wishlistApi.getWishlist = function() {
          try {
            const stored = localStorage.getItem(WISHLIST_STORAGE_KEY);
            if (!stored) return [];
            const parsed = JSON.parse(stored);
            if (!Array.isArray(parsed)) return [];
            return parsed
              .map(wishlistApi.normalizeItem)
              .filter(function(item) {
                return item && item.id;
              });
          } catch (error) {
            return [];
          }
        };

        wishlistApi.saveWishlist = function(wishlist) {
          try {
            localStorage.setItem(WISHLIST_STORAGE_KEY, JSON.stringify(wishlist));
          } catch (error) {
            console.warn('Wishlist save error', error);
          }
        };

        wishlistApi.isInWishlist = function(productId) {
          const id = productId ? productId.toString() : '';
          const wishlist = wishlistApi.getWishlist();
          return wishlist.some(function(item) {
            return item.id && item.id.toString() === id;
          });
        };

        // Disable wishlist toast bridging in cart
        wishlistApi.showToast = function(message) {};
      }

      return wishlistApi;
    }

    // Initialize wishlist buttons
    function initWishlistButtons() {
      const wishlistApi = ensureWishlistApi();
      const wishlistButtons = document.querySelectorAll('[data-wishlist-toggle]');

      wishlistButtons.forEach(function(button) {
        const productId = button.getAttribute('data-product-id') || '';
        const wishlistText = button.querySelector('.wishlist-text') || button;
        
        // Set initial state
        if (wishlistApi.isInWishlist(productId)) {
          button.classList.add('is-in-wishlist');
          if (wishlistText.textContent) {
            wishlistText.textContent = 'Remove from Wish List';
          }
        } else {
          button.classList.remove('is-in-wishlist');
          if (wishlistText.textContent) {
            wishlistText.textContent = 'Move to Wish List';
          }
        }

        button.addEventListener('click', function(e) {
          e.preventDefault();
          const productId = this.getAttribute('data-product-id') || '';
          if (!productId) return;

          const get = (name) => this.getAttribute(name) || '';
          const item = {
            id: productId,
            title: get('data-product-title'),
            handle: get('data-product-handle'),
            url: get('data-product-url'),
            sku: get('data-product-sku'),
            price: get('data-product-price'),
            price_formatted: get('data-product-price-formatted'),
            compare_price: '',
            compare_price_formatted: '',
            image: get('data-product-image'),
            variant_id: get('data-product-variant-id')
          };

          const wishlist = wishlistApi.getWishlist();
          const existingIndex = wishlist.findIndex(function(w) {
            return w.id === productId;
          });

          if (existingIndex > -1) {
            wishlist.splice(existingIndex, 1);
            this.classList.remove('is-in-wishlist');
            wishlistText.textContent = 'Move to Wish List';
            wishlistApi.showToast('Removed from wishlist');
          } else {
            wishlist.push(item);
            this.classList.add('is-in-wishlist');
            wishlistText.textContent = 'Remove from Wish List';
            wishlistApi.showToast('Added to wishlist');
          }

          wishlistApi.saveWishlist(wishlist);
          
          // Dispatch update event
          if (window.dispatchEvent) {
            window.dispatchEvent(new CustomEvent('wishlist:updated', { detail: wishlist }));
          }
        });
      });

      // Listen for external wishlist updates
      document.addEventListener('wishlist:updated', function() {
        wishlistButtons.forEach(function(button) {
          const productId = button.getAttribute('data-product-id') || '';
          const wishlistText = button.querySelector('.wishlist-text') || button;
          if (wishlistApi.isInWishlist(productId)) {
            button.classList.add('is-in-wishlist');
            if (wishlistText.textContent) {
              wishlistText.textContent = 'Remove from Wish List';
            }
          } else {
            button.classList.remove('is-in-wishlist');
            if (wishlistText.textContent) {
              wishlistText.textContent = 'Move to Wish List';
            }
          }
        });
      });
    }

    // Add another item handler
    function initAddAnotherButtons() {
      const addAnotherButtons = document.querySelectorAll('[data-add-another]');

      addAnotherButtons.forEach(function(button) {
        button.addEventListener('click', function(e) {
          e.preventDefault();
          const variantId = this.getAttribute('data-variant-id');
          const productTitle = this.getAttribute('data-product-title') || 'item';

          if (!variantId) {
            showToast('Unable to add item. Missing variant information.');
            return;
          }

          // Disable button during request
          const originalText = this.textContent;
          this.disabled = true;
          this.textContent = 'ADDING...';

          // Add unique property to ensure separate line items
          const uniqueId = Date.now().toString() + '_' + Math.random().toString(36).substr(2, 9);

          fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json'
            },
            body: JSON.stringify({
              items: [
                {
                  id: Number(variantId),
                  quantity: 1,
                  properties: {
                    '_line_item_id': uniqueId
                  }
                }
              ]
            })
          })
            .then(function(response) {
              if (!response.ok) {
                throw new Error('Add to cart failed');
              }
              return response.json();
            })
            .then(function() {
              return fetch('/cart.js', { headers: { Accept: 'application/json' } });
            })
            .then(function(response) {
              if (!response.ok) {
                throw new Error('Cart fetch failed');
              }
              return response.json();
            })
            .then(function(cart) {
              showToast('Added another ' + productTitle);
              
              // Update cart summary
              updateCartSummaryDisplay(cart.total_price || 0);

              // Trigger cart update event
              if (window.dispatchEvent) {
                window.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
                window.dispatchEvent(new CustomEvent('cart:refresh'));
              }

              // Reload page to show new item
              window.location.reload();
            })
            .catch(function(error) {
              console.error('Error adding another item:', error);
              showToast('Unable to add item. Please try again.');
              button.disabled = false;
              button.textContent = originalText;
            });
        });
      });
    }

    // Show remove confirmation dialog
    function showRemoveConfirmation(cartItem, lineIndex, removeBtn) {
      const confirmDialog = cartItem.querySelector('[data-remove-confirm]');
      if (!confirmDialog) return;

      // Hide any other open confirmation dialogs first
      document.querySelectorAll('[data-remove-confirm]').forEach(function(dialog) {
        if (dialog !== confirmDialog) {
          dialog.style.display = 'none';
        }
      });

      // Show dialog
      confirmDialog.style.display = 'flex';

      // Get buttons (refresh in case dialog was already used)
      let yesBtn = confirmDialog.querySelector('[data-remove-yes]');
      let cancelBtn = confirmDialog.querySelector('[data-remove-cancel]');
      let overlay = confirmDialog.querySelector('.cart-page__remove-confirm-overlay');

      // Cleanup function
      function cleanup() {
        confirmDialog.style.display = 'none';
        // Re-enable remove button state
        removeBtn.disabled = false;
        removeBtn.style.opacity = '1';
        cartItem.style.opacity = '1';
      }

      // Handle YES button click
      function handleYes(e) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        cleanup();

        // Disable the button to prevent multiple clicks
        removeBtn.disabled = true;
        removeBtn.style.opacity = '0.5';
        cartItem.style.opacity = '0.5';
        cartItem.style.transition = 'opacity 0.3s ease';

        // Proceed with removal
        removeCartItem(lineIndex, function (cart) {
          // Check if cart is empty or has no items
          const isEmpty = !cart || cart.item_count === 0 || (cart.items && cart.items.length === 0);

          // Remove the item from DOM
          setTimeout(function () {
            cartItem.remove();

            // If cart is empty, reload to show empty state
            if (isEmpty) {
              window.location.reload();
              return;
            }

            // Refresh cart state to get updated totals and item list
            fetchCartState()
              .then(function (updatedCart) {
                if (updatedCart && updatedCart.items && updatedCart.items.length > 0) {
                  // Update all prices and totals from server
                  if (typeof updatePricesFromCart === 'function') {
                    updatePricesFromCart(updatedCart);
                  }

                  // Update cart summary totals
                  updateCartSummaryDisplay(updatedCart.total_price || 0, updatedCart.total_tax || updatedCart.tax_price || 0);

                  // Update button states for remaining items
                  const remainingInputs = document.querySelectorAll('[data-quantity-input]');
                  if (remainingInputs.length && typeof updateQuantityButtons === 'function') {
                    remainingInputs.forEach(function (input) {
                      updateQuantityButtons(input);
                    });
                  }

                  // Dispatch cart update event for header badge and other listeners
                  if (window.dispatchEvent) {
                    window.dispatchEvent(new CustomEvent('cart:updated', { detail: updatedCart }));
                    window.dispatchEvent(new CustomEvent('cart:refresh'));
                  }
                } else {
                  // Cart became empty, reload
                  window.location.reload();
                }
              })
              .catch(function (error) {
                console.warn('Error refreshing cart after removal:', error);
                // If we can't fetch cart, check if we should reload
                if (!cart || cart.item_count === 0) {
                  window.location.reload();
                } else {
                  // Fallback: try to update summary from the cart response we already have
                  if (cart && cart.total_price !== undefined) {
                    updateCartSummaryDisplay(cart.total_price);
                  }
                }
              });
          }, 300);
        });
      }

      // Handle CANCEL button click
      function handleCancel(e) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        cleanup();
      }

      // Handle overlay click (outside dialog content)
      function handleOverlayClick(e) {
        if (e.target === overlay || e.target.classList.contains('cart-page__remove-confirm-overlay')) {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          cleanup();
        }
      }

      // Handle Escape key
      function handleEscape(e) {
        if (e.key === 'Escape' && confirmDialog.style.display === 'flex') {
          e.preventDefault();
          cleanup();
        }
      }

      // Add event listeners (using once: true to auto-remove after first call)
      if (yesBtn) {
        yesBtn.addEventListener('click', handleYes, { once: true });
      }
      if (cancelBtn) {
        cancelBtn.addEventListener('click', handleCancel, { once: true });
      }
      if (overlay) {
        overlay.addEventListener('click', handleOverlayClick, { once: true });
      }
      
      // Close on Escape key (attach once per dialog open)
      document.addEventListener('keydown', handleEscape, { once: true });
    }

    // Remove item handler - Show confirmation first
    removeButtons.forEach(function (button) {
      button.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        
        const lineIndex = parseInt(this.getAttribute('data-line-index'));
        const cartItem = document.querySelector(`[data-cart-item][data-line-index="${lineIndex}"]`);

        if (cartItem) {
          // Show confirmation dialog on top of this specific product card
          showRemoveConfirmation(cartItem, lineIndex, button);
        }
      });
    });

    // Initialize gift wrapping accordions
    function initGiftWrappingAccordions() {
      const accordions = document.querySelectorAll('[data-gift-wrapping-accordion]');

      accordions.forEach(function(accordion) {
        const header = accordion.querySelector('.cart-page__gift-wrapping-header');
        const content = accordion.querySelector('[data-gift-wrapping-content]');
        const checkbox = accordion.querySelector('[data-gift-wrapping-checkbox]');
        const text = accordion.querySelector('.cart-page__gift-wrapping-text');
        const chevron = accordion.querySelector('[data-gift-wrapping-chevron]');

        if (!header || !content) return;

        // Initialize state - collapsed by default
        accordion.setAttribute('data-expanded', 'false');

        // Function to toggle accordion
        function toggleAccordion(shouldExpand) {
          const isExpanded = shouldExpand !== undefined ? shouldExpand : accordion.getAttribute('data-expanded') !== 'true';
          accordion.setAttribute('data-expanded', isExpanded ? 'true' : 'false');
          
          // Sync checkbox with accordion state
          if (checkbox) {
            checkbox.checked = isExpanded;
          }
        }

        // Click handler for header (excluding checkbox)
        function handleHeaderClick(e) {
          // If clicking on checkbox, let it handle its own change event
          if (e.target === checkbox || (checkbox && checkbox === e.target.closest('[data-gift-wrapping-checkbox]'))) {
            // Checkbox change event will handle the sync
            return;
          }

          // For all other clicks, toggle accordion
          e.preventDefault();
          e.stopPropagation();
          toggleAccordion();
        }

        // Attach click handler to header
        header.addEventListener('click', handleHeaderClick);

        // Click handler for text specifically
        if (text) {
          text.addEventListener('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            toggleAccordion();
          });
        }

        // Click handler for chevron specifically
        if (chevron) {
          chevron.addEventListener('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            toggleAccordion();
          });
        }

        // Sync accordion with checkbox changes
        if (checkbox) {
          checkbox.addEventListener('change', function(e) {
            e.stopPropagation();
            const isChecked = this.checked;
            accordion.setAttribute('data-expanded', isChecked ? 'true' : 'false');
          });

          // Initialize state based on checkbox if already checked
          if (checkbox.checked) {
            accordion.setAttribute('data-expanded', 'true');
          }
        }
      });
    }

    // Initialize Gift Message Modal
    function initGiftMessageModal() {
      const modal = document.getElementById('gift-message-modal');
      const triggers = document.querySelectorAll('[data-gift-message-trigger]');
      const closeBtn = document.querySelector('[data-gift-message-close]');
      const overlay = modal ? modal.querySelector('.cart-page__modal-overlay') : null;
      const form = modal ? modal.querySelector('[data-gift-message-form]') : null;
      const textarea = modal ? modal.querySelector('[data-gift-message-textarea]') : null;
      const charCount = modal ? modal.querySelector('[data-char-count]') : null;
      const messageTypeRadios = modal ? modal.querySelectorAll('[data-message-type-radio]') : null;
      const composeSection = modal ? modal.querySelector('[data-message-compose-section]') : null;
      const styleButtons = modal ? modal.querySelectorAll('.cart-page__modal-style-btn[data-style]') : null;
      const confirmBtn = modal ? modal.querySelector('[data-gift-message-confirm]') : null;
      const branding = modal ? modal.querySelector('[data-message-branding]') : null;

      if (!modal) return;

      let currentItemKey = null;
      let currentLineIndex = null;
      let selectedStyle = 'block';

      // Get cart item by line index
      function getCartItem(lineIndex) {
        const cartItems = document.querySelectorAll('[data-cart-item]');
        let lineNum = 1;
        for (let i = 0; i < cartItems.length; i++) {
          if (lineNum === lineIndex) {
            return cartItems[i];
          }
          lineNum++;
        }
        return null;
      }

      // Show loading state
      function showGiftMessageLoading(lineIndex, show) {
        const cartItem = getCartItem(lineIndex);
        if (!cartItem) return;
        const displaySection = cartItem.querySelector('[data-gift-message-section]');
        const loadingEl = displaySection ? displaySection.querySelector('[data-gift-message-loading]') : null;
        const actionsEl = displaySection ? displaySection.querySelector('.cart-page__item-gift-message-actions') : null;
        
        if (loadingEl) {
          if (show) {
            loadingEl.style.display = 'flex';
          } else {
            loadingEl.style.display = 'none';
          }
        }
        if (actionsEl) {
          if (show) {
            actionsEl.style.display = 'none';
          } else {
            actionsEl.style.display = 'flex';
          }
        }
      }

      // Update gift message display on cart item
      function updateGiftMessageDisplay(lineIndex, message, style, messageType) {
        const cartItem = getCartItem(lineIndex);
        if (!cartItem) return;

        let displaySection = cartItem.querySelector('[data-gift-message-section]');
        const messageValue = displaySection ? displaySection.querySelector('[data-gift-message-value]') : null;
        const messageStyle = displaySection ? displaySection.querySelector('[data-gift-message-style]') : null;
        const triggerBtn = cartItem.querySelector('[data-gift-message-trigger]');
        const optionsContainer = cartItem.querySelector('[data-item-options-container]');

        // If display section doesn't exist, create it
        if (!displaySection && optionsContainer) {
          displaySection = document.createElement('div');
          displaySection.className = 'cart-page__item-gift-message-section';
          displaySection.setAttribute('data-gift-message-section', '');
          displaySection.innerHTML = `
            <div class="cart-page__item-gift-message-header">
              <span class="cart-page__item-gift-message-label">GIFT MESSAGE <span class="cart-page__item-gift-message-style" data-gift-message-style>(REGULAR)</span>:</span>
              <span class="cart-page__item-gift-message-value" data-gift-message-value></span>
            </div>
            <div class="cart-page__item-gift-message-actions">
              <button type="button" class="cart-page__item-action-link cart-page__item-action-link--button" data-gift-message-modify data-line-index="${lineIndex}" data-item-key="${currentItemKey}">Modify</button>
              <button type="button" class="cart-page__item-action-link cart-page__item-action-link--button" data-gift-message-remove data-line-index="${lineIndex}" data-item-key="${currentItemKey}">Remove</button>
            </div>
            <div class="cart-page__item-loading" data-gift-message-loading style="display: none;">
              <span class="cart-page__item-loading-spinner"></span>
              <span class="cart-page__item-loading-text">Updating...</span>
            </div>
          `;
          if (triggerBtn) {
            optionsContainer.insertBefore(displaySection, triggerBtn);
          } else {
            optionsContainer.appendChild(displaySection);
          }
        }

        if (messageType === 'blank' || (message && message.trim())) {
          if (displaySection) {
            displaySection.style.display = 'block';
            const valueEl = displaySection.querySelector('[data-gift-message-value]');
            const styleEl = displaySection.querySelector('[data-gift-message-style]');
            if (valueEl) {
              valueEl.textContent = messageType === 'blank' ? '(Blank card)' : message;
            }
            if (styleEl) {
              styleEl.textContent = '(' + (style === 'block' ? 'REGULAR' : 'CURSIVE') + ')';
            }
          }
          if (triggerBtn) {
            triggerBtn.classList.add('is-hidden');
          }
        } else {
          if (displaySection) {
            displaySection.style.display = 'none';
          }
          if (triggerBtn) {
            triggerBtn.classList.remove('is-hidden');
          }
        }
      }

      // Load gift message from cart item properties
      function loadGiftMessage(lineIndex, itemKey) {
        const cartItem = getCartItem(lineIndex);
        if (!cartItem) return null;

        // Try to get from cart item display (if already loaded from Liquid)
        const displaySection = cartItem.querySelector('[data-gift-message-section]');
        const messageValue = displaySection ? displaySection.querySelector('[data-gift-message-value]') : null;
        const messageStyle = displaySection ? displaySection.querySelector('[data-gift-message-style]') : null;
        
        if (displaySection && displaySection.style.display !== 'none' && messageValue && messageValue.textContent.trim()) {
          const message = messageValue.textContent.trim();
          const styleText = messageStyle ? messageStyle.textContent.replace(/[()]/g, '').trim() : 'REGULAR';
          const style = styleText === 'CURSIVE' ? 'cursive' : 'block';
          const type = message === '(Blank card)' ? 'blank' : 'compose';
          
          return {
            message: type === 'blank' ? '' : message,
            style: style,
            type: type
          };
        }

        // Fallback to localStorage
        const key = itemKey || currentItemKey;
        if (key) {
          const stored = localStorage.getItem('cart_gift_message_' + key);
          if (stored) {
            try {
              return JSON.parse(stored);
            } catch (e) {
              return null;
            }
          }
        }
        return null;
      }

      // Close modal
      function closeModal() {
        modal.classList.remove('is-open');
        document.body.style.overflow = '';
        currentItemKey = null;
        currentLineIndex = null;
      }

      // Style button click handler
      if (styleButtons) {
        styleButtons.forEach(function(btn) {
          btn.addEventListener('click', function() {
            styleButtons.forEach(function(b) {
              b.classList.remove('cart-page__modal-style-btn--active');
            });
            this.classList.add('cart-page__modal-style-btn--active');
            selectedStyle = this.dataset.style;
            
            if (textarea && branding) {
              if (selectedStyle === 'cursive') {
                textarea.style.fontFamily = "'Brush Script MT', cursive";
                branding.style.fontFamily = "'Brush Script MT', cursive";
              } else {
                textarea.style.fontFamily = 'inherit';
                branding.style.fontFamily = "'Brush Script MT', cursive";
              }
            }
          });
        });
      }

      // Message type radio handler
      if (messageTypeRadios) {
        messageTypeRadios.forEach(function(radio) {
          radio.addEventListener('change', function() {
            if (composeSection) {
              if (this.value === 'compose') {
                composeSection.style.display = 'block';
              } else {
                composeSection.style.display = 'none';
              }
            }
          });
        });
      }

      // Textarea character count
      if (textarea && charCount) {
        textarea.addEventListener('input', function() {
          const length = this.value.length;
          charCount.textContent = length;
        });
      }

      // Confirm button handler
      if (confirmBtn) {
        confirmBtn.addEventListener('click', function() {
          const selectedType = modal.querySelector('input[name="gift-message-type"]:checked');
          let message = '';
          let messageType = 'compose';

          if (selectedType && selectedType.value === 'blank') {
            messageType = 'blank';
            message = '';
          } else if (textarea && textarea.value.trim()) {
            message = textarea.value.trim();
            messageType = 'compose';
          } else {
            console.warn('Gift message validation failed: no message or blank card selected');
            return;
          }

          // Save to localStorage
          const giftMessageData = {
            message: message,
            style: selectedStyle,
            type: messageType
          };
          localStorage.setItem('cart_gift_message_' + currentItemKey, JSON.stringify(giftMessageData));

          // Update display immediately (optimistic update)
          updateGiftMessageDisplay(currentLineIndex, message, selectedStyle, messageType);

          // Close modal
          closeModal();

          // Show loading state briefly (subtle feedback)
          showGiftMessageLoading(currentLineIndex, true);

          // Hide loading after a short delay
          setTimeout(function() {
            showGiftMessageLoading(currentLineIndex, false);
          }, 300);
        });
      }

      // Modify button handler (event delegation)
      document.addEventListener('click', function(e) {
        if (e.target.closest('[data-gift-message-modify]')) {
          e.preventDefault();
          const button = e.target.closest('[data-gift-message-modify]');
          const cartItem = button.closest('[data-cart-item]');
          if (!cartItem) return;
          
          const lineIndex = parseInt(button.dataset.lineIndex) || Array.from(document.querySelectorAll('[data-cart-item]')).indexOf(cartItem) + 1;
          const itemKey = button.dataset.itemKey;
          const trigger = cartItem.querySelector('[data-gift-message-trigger]');
          
          // Set current values
          currentItemKey = itemKey;
          currentLineIndex = lineIndex;
          
          // Load existing data before opening modal
          const stored = loadGiftMessage(lineIndex);
          if (stored) {
            if (textarea) {
              textarea.value = stored.message || '';
              if (charCount) charCount.textContent = (stored.message || '').length;
            }
            selectedStyle = stored.style || 'block';
            if (styleButtons) {
              styleButtons.forEach(function(btn) {
                btn.classList.remove('cart-page__modal-style-btn--active');
                if (btn.dataset.style === selectedStyle) {
                  btn.classList.add('cart-page__modal-style-btn--active');
                }
              });
            }
            const radio = modal.querySelector('input[name="gift-message-type"][value="' + (stored.type || 'compose') + '"]');
            if (radio) radio.checked = true;
            if (composeSection) {
              composeSection.style.display = stored.type === 'blank' ? 'none' : 'block';
            }
          }
          
          // Open modal
              // Open modal by triggering the regular trigger
              if (trigger && !trigger.classList.contains('is-hidden')) {
                trigger.click();
              } else {
                modal.classList.add('is-open');
                document.body.style.overflow = 'hidden';
              }
        }
      });

      // Remove button handler (event delegation)
      document.addEventListener('click', function(e) {
        if (e.target.closest('[data-gift-message-remove]')) {
          e.preventDefault();
          const button = e.target.closest('[data-gift-message-remove]');
          const cartItem = button.closest('[data-cart-item]');
          if (!cartItem) return;
          
          const lineIndex = parseInt(button.dataset.lineIndex) || Array.from(document.querySelectorAll('[data-cart-item]')).indexOf(cartItem) + 1;
          const itemKey = button.dataset.itemKey || cartItem.querySelector('[data-gift-message-trigger]')?.dataset.itemKey;
          
          // Remove from localStorage
          if (itemKey) {
            localStorage.removeItem('cart_gift_message_' + itemKey);
          }

          // Update display immediately (optimistic update)
          updateGiftMessageDisplay(lineIndex, '', 'block', 'compose');
          
          // Show loading state briefly (subtle feedback)
          showGiftMessageLoading(lineIndex, true);

          // Hide loading after a short delay
          setTimeout(function() {
            showGiftMessageLoading(lineIndex, false);
          }, 300);
        }
      });

      // Close handlers
      if (closeBtn) {
        closeBtn.addEventListener('click', closeModal);
      }
      if (overlay) {
        overlay.addEventListener('click', closeModal);
      }

      // Escape key to close
      document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && modal.classList.contains('is-open')) {
          closeModal();
        }
      });

      // Trigger handlers
      triggers.forEach(function(trigger) {
        trigger.addEventListener('click', function(e) {
          e.preventDefault();
          const itemKey = this.dataset.itemKey;
          const lineIndex = parseInt(this.dataset.lineIndex) || 1;
          currentItemKey = itemKey;
          currentLineIndex = lineIndex;
          modal.classList.add('is-open');
          document.body.style.overflow = 'hidden';
          
          // Load existing data
          const stored = loadGiftMessage(lineIndex, itemKey);
          if (stored) {
            if (textarea) {
              textarea.value = stored.message || '';
              textarea.style.fontFamily = stored.style === 'cursive' ? "'Brush Script MT', cursive" : 'inherit';
              if (charCount) charCount.textContent = (stored.message || '').length;
            }
            selectedStyle = stored.style || 'block';
            const radio = modal.querySelector('input[name="gift-message-type"][value="' + (stored.type || 'compose') + '"]');
            if (radio) radio.checked = true;
            if (composeSection) {
              composeSection.style.display = stored.type === 'blank' ? 'none' : 'block';
            }
          } else {
            // Reset form
            if (form) {
              form.reset();
              const defaultRadio = modal.querySelector('input[name="gift-message-type"][value="compose"]');
              if (defaultRadio) defaultRadio.checked = true;
              if (textarea) {
                textarea.value = '';
                textarea.style.fontFamily = 'inherit';
                if (charCount) charCount.textContent = '0';
              }
              if (composeSection) composeSection.style.display = 'block';
            }
            selectedStyle = 'block';
          }

          // Update style buttons
          if (styleButtons) {
            styleButtons.forEach(function(btn) {
              btn.classList.remove('cart-page__modal-style-btn--active');
              if (btn.dataset.style === selectedStyle) {
                btn.classList.add('cart-page__modal-style-btn--active');
              }
            });
          }
        });
      });

      // Initialize display on page load
      function initializeGiftMessageDisplays() {
        const cartItems = document.querySelectorAll('[data-cart-item]');
        cartItems.forEach(function(cartItem, index) {
          const lineIndex = index + 1;
          const trigger = cartItem.querySelector('[data-gift-message-trigger]');
          if (!trigger) return;
          const itemKey = trigger.dataset.itemKey;
          
          // Check if display section already exists (from Liquid)
          const displaySection = cartItem.querySelector('[data-gift-message-section]');
          const messageValue = displaySection ? displaySection.querySelector('[data-gift-message-value]') : null;
          
          if (displaySection && displaySection.style.display !== 'none' && messageValue && messageValue.textContent.trim()) {
            // Already displayed from Liquid, update localStorage
            const message = messageValue.textContent.trim();
            const messageStyle = displaySection.querySelector('[data-gift-message-style]');
            const styleText = messageStyle ? messageStyle.textContent.replace(/[()]/g, '').trim() : 'REGULAR';
            const style = styleText === 'CURSIVE' ? 'cursive' : 'block';
            const type = message === '(Blank card)' ? 'blank' : 'compose';
            
            const data = {
              message: type === 'blank' ? '' : message,
              style: style,
              type: type
            };
            localStorage.setItem('cart_gift_message_' + itemKey, JSON.stringify(data));
          } else {
            // Check localStorage and update display
            const stored = localStorage.getItem('cart_gift_message_' + itemKey);
            if (stored) {
              try {
                const data = JSON.parse(stored);
                if (data.message || data.type === 'blank') {
                  updateGiftMessageDisplay(lineIndex, data.message || '', data.style || 'block', data.type || 'compose');
                }
              } catch (e) {
                console.error('Error parsing stored gift message:', e);
              }
            }
          }
        });
      }

      // Initialize on page load
      initializeGiftMessageDisplays();
    }

    // Initialize Engraving Modal
    function initEngravingModal() {
      const modal = document.getElementById('engraving-modal');
      const triggers = document.querySelectorAll('[data-engraving-trigger]');
      const closeBtn = document.querySelector('[data-engraving-close]');
      const overlay = modal ? modal.querySelector('.cart-page__modal-overlay') : null;
      const form = modal ? modal.querySelector('[data-engraving-form]') : null;
      const productImage = modal ? modal.querySelector('[data-engraving-product-image]') : null;
      const styleButtons = modal ? modal.querySelectorAll('.cart-page__modal-style-btn[data-engraving-style]') : null;
      const messageInput = modal ? modal.querySelector('[data-engraving-message-input]') : null;
      const disclaimerCheckbox = modal ? modal.querySelector('[data-engraving-disclaimer-checkbox]') : null;
      const saveBtn = modal ? modal.querySelector('[data-engraving-save]') : null;
      const cancelBtn = modal ? modal.querySelector('[data-engraving-cancel]') : null;

      if (!modal) return;

      let currentItemKey = null;
      let currentLineIndex = null;
      let currentVariantId = null;
      let selectedStyle = 'block';

      // Get cart item by line index
      function getCartItem(lineIndex) {
        const cartItems = document.querySelectorAll('[data-cart-item]');
        let lineNum = 1;
        for (let i = 0; i < cartItems.length; i++) {
          if (lineNum === lineIndex) {
            return cartItems[i];
          }
          lineNum++;
        }
        return null;
      }

      // Show loading state for engraving
      function showEngravingLoading(lineIndex, show) {
        const cartItem = getCartItem(lineIndex);
        if (!cartItem) return;
        const displaySection = cartItem.querySelector('[data-engraving-section]');
        const loadingEl = displaySection ? displaySection.querySelector('[data-engraving-loading]') : null;
        const actionsEl = displaySection ? displaySection.querySelector('.cart-page__item-engraving-actions') : null;
        
        if (loadingEl) {
          if (show) {
            loadingEl.style.display = 'flex';
          } else {
            loadingEl.style.display = 'none';
          }
        }
        if (actionsEl) {
          if (show) {
            actionsEl.style.display = 'none';
          } else {
            actionsEl.style.display = 'flex';
          }
        }
      }

      // Update engraving display on cart item
      function updateEngravingDisplay(lineIndex, message, itemKey) {
        const cartItem = getCartItem(lineIndex);
        if (!cartItem) return;

        let displaySection = cartItem.querySelector('[data-engraving-section]');
        const engravingValue = displaySection ? displaySection.querySelector('[data-engraving-value]') : null;
        const triggerBtn = cartItem.querySelector('[data-engraving-trigger]');
        const optionsContainer = cartItem.querySelector('[data-item-options-container]');

        // If display section doesn't exist, create it
        if (!displaySection && optionsContainer) {
          displaySection = document.createElement('div');
          displaySection.className = 'cart-page__item-engraving-section';
          displaySection.setAttribute('data-engraving-section', '');
          const variantId = triggerBtn ? triggerBtn.dataset.variantId : '';
          const productImage = triggerBtn ? triggerBtn.dataset.productImage : '';
          const itemKeyValue = itemKey || currentItemKey || triggerBtn ? triggerBtn.dataset.itemKey : '';
          displaySection.innerHTML = `
            <div class="cart-page__item-engraving-header">
              <span class="cart-page__item-engraving-label">ENGRAVING:</span>
              <span class="cart-page__item-engraving-value" data-engraving-value></span>
            </div>
            <p class="cart-page__item-engraving-note" data-engraving-note style="display: none;">Customized products are not eligible for a return</p>
            <div class="cart-page__item-engraving-actions">
              <button type="button" class="cart-page__item-action-link cart-page__item-action-link--button" data-engraving-modify data-line-index="${lineIndex}" data-item-key="${itemKeyValue}" data-variant-id="${variantId}" data-product-image="${productImage}">Modify</button>
              <button type="button" class="cart-page__item-action-link cart-page__item-action-link--button" data-engraving-remove data-line-index="${lineIndex}" data-item-key="${itemKeyValue}">Remove</button>
            </div>
            <div class="cart-page__item-loading" data-engraving-loading style="display: none;">
              <span class="cart-page__item-loading-spinner"></span>
              <span class="cart-page__item-loading-text">Updating...</span>
            </div>
          `;
          if (triggerBtn) {
            optionsContainer.insertBefore(displaySection, triggerBtn);
          } else {
            optionsContainer.appendChild(displaySection);
          }
        }

        if (message && message.trim()) {
          if (displaySection) {
            displaySection.style.display = 'block';
            const valueEl = displaySection.querySelector('[data-engraving-value]');
            if (valueEl) {
              valueEl.textContent = message;
            }
            const noteEl = displaySection.querySelector('[data-engraving-note]');
            if (noteEl) {
              noteEl.style.display = 'block';
            }
          }
          if (triggerBtn) {
            triggerBtn.classList.add('is-hidden');
          }
        } else {
          if (displaySection) {
            displaySection.style.display = 'none';
            const noteEl = displaySection.querySelector('[data-engraving-note]');
            if (noteEl) {
              noteEl.style.display = 'none';
            }
          }
          if (triggerBtn) {
            triggerBtn.classList.remove('is-hidden');
          }
        }
      }

      // Load engraving from cart item properties
      function loadEngraving(lineIndex, itemKey) {
        const cartItem = getCartItem(lineIndex);
        if (!cartItem) return null;

        // Try to get from cart item display (if already loaded from Liquid)
        const displaySection = cartItem.querySelector('[data-engraving-section]');
        const engravingValue = displaySection ? displaySection.querySelector('[data-engraving-value]') : null;
        
        if (displaySection && displaySection.style.display !== 'none' && engravingValue && engravingValue.textContent.trim()) {
          const message = engravingValue.textContent.trim();
          
          // Try to get style from localStorage or default to block
          const key = itemKey || currentItemKey;
          if (key) {
            const stored = localStorage.getItem('cart_engraving_' + key);
            if (stored) {
              try {
                const data = JSON.parse(stored);
                return {
                  message: message,
                  style: data.style || 'block'
                };
              } catch (e) {
                return {
                  message: message,
                  style: 'block'
                };
              }
            }
          }
          
          return {
            message: message,
            style: 'block'
          };
        }

        // Fallback to localStorage
        const key = itemKey || currentItemKey;
        if (key) {
          const stored = localStorage.getItem('cart_engraving_' + key);
          if (stored) {
            try {
              return JSON.parse(stored);
            } catch (e) {
              return null;
            }
          }
        }
        return null;
      }

      // Validate form
      function validateForm() {
        const hasMessage = messageInput && messageInput.value.trim().length > 0;
        const hasDisclaimer = disclaimerCheckbox && disclaimerCheckbox.checked;
        return hasMessage && hasDisclaimer;
      }

      // Update save button state
      function updateSaveButton() {
        if (saveBtn) {
          const isValid = validateForm();
          saveBtn.disabled = !isValid;
        }
      }

      // Close modal
      function closeModal() {
        modal.classList.remove('is-open');
        document.body.style.overflow = '';
        currentItemKey = null;
        currentLineIndex = null;
        currentVariantId = null;
      }

      // Style button click handler
      if (styleButtons) {
        styleButtons.forEach(function(btn) {
          btn.addEventListener('click', function() {
            styleButtons.forEach(function(b) {
              b.classList.remove('cart-page__modal-style-btn--active');
            });
            this.classList.add('cart-page__modal-style-btn--active');
            selectedStyle = this.dataset.engravingStyle;
            
            if (messageInput) {
              if (selectedStyle === 'cursive') {
                messageInput.style.fontFamily = "'Brush Script MT', cursive";
              } else {
                messageInput.style.fontFamily = 'inherit';
              }
            }
          });
        });
      }

      // Input handlers
      if (messageInput) {
        messageInput.addEventListener('input', function() {
          updateSaveButton();
        });
      }

      if (disclaimerCheckbox) {
        disclaimerCheckbox.addEventListener('change', function() {
          updateSaveButton();
        });
      }

      // Save button handler
      if (saveBtn) {
        saveBtn.addEventListener('click', function() {
          if (!validateForm()) {
            console.warn('Engraving validation failed: required fields or disclaimer missing');
            return;
          }

          const message = messageInput ? messageInput.value.trim() : '';
          if (!message) {
            console.warn('Engraving validation failed: no message entered');
            return;
          }

          // Save to localStorage
          const engravingData = {
            message: message,
            style: selectedStyle
          };
          localStorage.setItem('cart_engraving_' + currentItemKey, JSON.stringify(engravingData));

          // Update display immediately (optimistic update)
          updateEngravingDisplay(currentLineIndex, message, currentItemKey);
          
          // Close modal
          closeModal();

          // Show loading state briefly (subtle feedback)
          showEngravingLoading(currentLineIndex, true);

          // Hide loading after a short delay
          setTimeout(function() {
            showEngravingLoading(currentLineIndex, false);
          }, 300);
        });
      }

      // Modify button handler (event delegation)
      document.addEventListener('click', function(e) {
        if (e.target.closest('[data-engraving-modify]')) {
          e.preventDefault();
          const button = e.target.closest('[data-engraving-modify]');
          const cartItem = button.closest('[data-cart-item]');
          if (!cartItem) return;
          
          const lineIndex = parseInt(button.dataset.lineIndex) || Array.from(document.querySelectorAll('[data-cart-item]')).indexOf(cartItem) + 1;
          const itemKey = button.dataset.itemKey;
          const variantId = button.dataset.variantId || cartItem.querySelector('[data-engraving-trigger]')?.dataset.variantId;
          const productImageUrl = button.dataset.productImage || cartItem.querySelector('[data-engraving-trigger]')?.dataset.productImage;
          
          // Set current values
          currentItemKey = itemKey;
          currentLineIndex = lineIndex;
          currentVariantId = variantId;
          
          // Set product image
          if (productImage && productImageUrl) {
            productImage.src = productImageUrl;
            productImage.alt = 'Product';
          }
          
          // Load existing data before opening modal
          const stored = loadEngraving(lineIndex);
          if (stored && stored.message) {
            if (messageInput) {
              messageInput.value = stored.message;
              messageInput.style.fontFamily = stored.style === 'cursive' ? "'Brush Script MT', cursive" : 'inherit';
            }
            selectedStyle = stored.style || 'block';
            if (styleButtons) {
              styleButtons.forEach(function(btn) {
                btn.classList.remove('cart-page__modal-style-btn--active');
                if (btn.dataset.engravingStyle === selectedStyle) {
                  btn.classList.add('cart-page__modal-style-btn--active');
                }
              });
            }
            if (disclaimerCheckbox) {
              disclaimerCheckbox.checked = true;
            }
          } else {
            // Reset form
            if (form) {
              form.reset();
              if (messageInput) {
                messageInput.value = '';
                messageInput.style.fontFamily = 'inherit';
              }
              if (disclaimerCheckbox) {
                disclaimerCheckbox.checked = false;
              }
            }
            selectedStyle = 'block';
          }

          // Update style buttons
          if (styleButtons) {
            styleButtons.forEach(function(btn) {
              btn.classList.remove('cart-page__modal-style-btn--active');
              if (btn.dataset.engravingStyle === selectedStyle) {
                btn.classList.add('cart-page__modal-style-btn--active');
              }
            });
          }
          
          updateSaveButton();
          
          // Open modal
          modal.classList.add('is-open');
          document.body.style.overflow = 'hidden';
        }
      });

      // Remove button handler (event delegation)
      document.addEventListener('click', function(e) {
        if (e.target.closest('[data-engraving-remove]')) {
          e.preventDefault();
          const button = e.target.closest('[data-engraving-remove]');
          const cartItem = button.closest('[data-cart-item]');
          if (!cartItem) return;
          
          const lineIndex = parseInt(button.dataset.lineIndex) || Array.from(document.querySelectorAll('[data-cart-item]')).indexOf(cartItem) + 1;
          const itemKey = button.dataset.itemKey || cartItem.querySelector('[data-engraving-trigger]')?.dataset.itemKey;
          
          // Remove from localStorage
          if (itemKey) {
            localStorage.removeItem('cart_engraving_' + itemKey);
          }

          // Update display immediately (optimistic update)
          updateEngravingDisplay(lineIndex, '', itemKey);
          
          // Show loading state briefly (subtle feedback)
          showEngravingLoading(lineIndex, true);

          // Hide loading after a short delay
          setTimeout(function() {
            showEngravingLoading(lineIndex, false);
          }, 300);
        }
      });

      // Cancel button handler
      if (cancelBtn) {
        cancelBtn.addEventListener('click', function(e) {
          e.preventDefault();
          closeModal();
        });
      }

      // Close handlers
      if (closeBtn) {
        closeBtn.addEventListener('click', closeModal);
      }
      if (overlay) {
        overlay.addEventListener('click', closeModal);
      }

      // Escape key to close
      document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && modal.classList.contains('is-open')) {
          closeModal();
        }
      });

      // Trigger handlers
      triggers.forEach(function(trigger) {
        trigger.addEventListener('click', function(e) {
          e.preventDefault();
          const itemKey = this.dataset.itemKey;
          const lineIndex = parseInt(this.dataset.lineIndex) || 1;
          const variantId = this.dataset.variantId;
          const imageUrl = this.dataset.productImage;
          
          currentItemKey = itemKey;
          currentLineIndex = lineIndex;
          currentVariantId = variantId;
          modal.classList.add('is-open');
          document.body.style.overflow = 'hidden';
          
          // Set product image
          if (productImage && imageUrl) {
            productImage.src = imageUrl;
            productImage.alt = 'Product';
          }

          // Set current values
          currentItemKey = itemKey;
          currentLineIndex = lineIndex;
          currentVariantId = variantId;
          
          // Set product image
          if (productImage && imageUrl) {
            productImage.src = imageUrl;
            productImage.alt = 'Product';
          }
          
          // Load existing data
          const stored = loadEngraving(lineIndex, itemKey);
          if (stored && stored.message) {
            if (messageInput) {
              messageInput.value = stored.message;
              messageInput.style.fontFamily = stored.style === 'cursive' ? "'Brush Script MT', cursive" : 'inherit';
            }
            selectedStyle = stored.style || 'block';
            if (disclaimerCheckbox) {
              disclaimerCheckbox.checked = true;
            }
          } else {
            // Reset form
            if (form) {
              form.reset();
              if (messageInput) {
                messageInput.value = '';
                messageInput.style.fontFamily = 'inherit';
              }
              if (disclaimerCheckbox) {
                disclaimerCheckbox.checked = false;
              }
            }
            selectedStyle = 'block';
          }

          // Update style buttons
          if (styleButtons) {
            styleButtons.forEach(function(btn) {
              btn.classList.remove('cart-page__modal-style-btn--active');
              if (btn.dataset.engravingStyle === selectedStyle) {
                btn.classList.add('cart-page__modal-style-btn--active');
              }
            });
          }
          
          updateSaveButton();
        });
      });

      // Initialize display on page load
      function initializeEngravingDisplays() {
        const cartItems = document.querySelectorAll('[data-cart-item]');
        cartItems.forEach(function(cartItem, index) {
          const lineIndex = index + 1;
          const trigger = cartItem.querySelector('[data-engraving-trigger]');
          if (!trigger) return;
          const itemKey = trigger.dataset.itemKey;
          
          // Check if display section already exists (from Liquid)
          const displaySection = cartItem.querySelector('[data-engraving-section]');
          const engravingValue = displaySection ? displaySection.querySelector('[data-engraving-value]') : null;
          
          if (displaySection && displaySection.style.display !== 'none' && engravingValue && engravingValue.textContent.trim()) {
            // Already displayed from Liquid, update localStorage
            const message = engravingValue.textContent.trim();
            const stored = localStorage.getItem('cart_engraving_' + itemKey);
            let style = 'block';
            if (stored) {
              try {
                const data = JSON.parse(stored);
                style = data.style || 'block';
              } catch (e) {
                console.error('Error parsing stored engraving:', e);
              }
            }
            const data = {
              message: message,
              style: style
            };
            localStorage.setItem('cart_engraving_' + itemKey, JSON.stringify(data));
          } else {
            // Check localStorage and update display
            const stored = localStorage.getItem('cart_engraving_' + itemKey);
            if (stored) {
              try {
                const data = JSON.parse(stored);
                if (data.message) {
                  updateEngravingDisplay(lineIndex, data.message, itemKey);
                }
              } catch (e) {
                console.error('Error parsing stored engraving:', e);
              }
            }
          }
        });
      }

      // Initialize on page load
      initializeEngravingDisplays();
    }

    // Initialize Checkout Interception - Save all customizations to cart properties
    function initCheckoutInterception() {
      const checkoutButton = document.getElementById('cart-checkout-button');
      const cartForm = document.querySelector('form[action*="/cart"]');
      
      if (!checkoutButton || !cartForm) return;

      let isProcessing = false;
      let shouldProceedToCheckout = false;

      // Handle checkout button click
      checkoutButton.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();

        // Check if we're already processing
        if (isProcessing || this.disabled || this.classList.contains('is-saving')) {
          return;
        }

        isProcessing = true;
        shouldProceedToCheckout = true;

        // Disable button and show loading state
        checkoutButton.disabled = true;
        checkoutButton.classList.add('is-saving');
        const originalText = checkoutButton.textContent;
        checkoutButton.textContent = 'SAVING CUSTOMIZATIONS...';

        // Collect all customizations from all cart items
        saveAllCustomizationsToCart()
          .then(function(success) {
            isProcessing = false;
            
            if (success) {
              // All customizations saved successfully
              checkoutButton.textContent = originalText;
              checkoutButton.disabled = false;
              checkoutButton.classList.remove('is-saving');
              showToast('Customizations saved! Proceeding to checkout...');
            } else {
              // Some errors occurred, but proceed anyway
              checkoutButton.textContent = originalText;
              checkoutButton.disabled = false;
              checkoutButton.classList.remove('is-saving');
              showToast('Some customizations may not be saved. Proceeding to checkout...');
            }
            
            // Proceed to checkout
            shouldProceedToCheckout = false; // Reset flag
            setTimeout(function() {
              // Redirect to checkout
              window.location.href = '/checkout';
            }, 800);
          })
          .catch(function(error) {
            console.error('Error saving customizations:', error);
            isProcessing = false;
            shouldProceedToCheckout = false;
            
            // Allow checkout anyway
            checkoutButton.textContent = originalText;
            checkoutButton.disabled = false;
            checkoutButton.classList.remove('is-saving');
            showToast('Proceeding to checkout...');
            
            setTimeout(function() {
              window.location.href = '/checkout';
            }, 1000);
          });
      });

      // Intercept form submission to save customizations before checkout
      cartForm.addEventListener('submit', function(e) {
        // Only intercept if checkout button was clicked or form has checkout action
        if (shouldProceedToCheckout || (e.submitter && e.submitter === checkoutButton)) {
          e.preventDefault();
          e.stopPropagation();
          
          if (!isProcessing) {
            checkoutButton.click(); // Trigger our click handler
          }
        }
      });
    }

    // Save all customizations to cart properties
    function saveAllCustomizationsToCart() {
      return fetch('/cart.js')
        .then(function(response) {
          if (!response.ok) {
            throw new Error('Failed to fetch cart');
          }
          return response.json();
        })
        .then(function(cart) {
          if (!cart || !cart.items || cart.items.length === 0) {
            return Promise.resolve(true);
          }

          // Build items array with properties
          const itemsToUpdate = [];
          
          cart.items.forEach(function(item, index) {
            const lineIndex = index + 1;
            const itemKey = item.key;
            const properties = {};
            
            // Preserve any existing properties that item might already have (except internal ones)
            if (item.properties && typeof item.properties === 'object') {
              Object.keys(item.properties).forEach(function(key) {
                if (key !== '_line_item_id') { // Skip internal ID property
                  properties[key] = item.properties[key];
                }
              });
            }

            // Get gift message customization (from localStorage takes priority, then existing properties)
            const giftMessageData = localStorage.getItem('cart_gift_message_' + itemKey);
            if (giftMessageData) {
              try {
                const data = JSON.parse(giftMessageData);
                if (data.message || data.type === 'blank') {
                  properties['Gift Message'] = data.type === 'blank' ? '(Blank card)' : data.message;
                  properties['Gift Message Style'] = data.style === 'block' ? 'REGULAR' : 'CURSIVE';
                  properties['Gift Message Type'] = data.type || 'compose';
                }
              } catch (e) {
                console.error('Error parsing gift message data:', e);
              }
            }

            // Get engraving customization (from localStorage takes priority, then existing properties)
            const engravingData = localStorage.getItem('cart_engraving_' + itemKey);
            if (engravingData) {
              try {
                const data = JSON.parse(engravingData);
                if (data.message) {
                  properties['Engraving'] = data.message;
                  properties['Engraving Style'] = data.style === 'block' ? 'REGULAR' : 'CURSIVE';
                }
              } catch (e) {
                console.error('Error parsing engraving data:', e);
              }
            }

            // Get gift wrapping preference (check checkbox in DOM)
            const cartItemElement = document.querySelector(`[data-item-key="${itemKey}"]`);
            if (cartItemElement) {
              const giftWrappingCheckbox = cartItemElement.querySelector('[data-gift-wrapping-checkbox]');
              if (giftWrappingCheckbox && giftWrappingCheckbox.checked) {
                properties['Gift Wrapping'] = 'Yes';
              } else if (item.properties && item.properties['Gift Wrapping']) {
                // Use existing property if checkbox is not checked
                properties['Gift Wrapping'] = item.properties['Gift Wrapping'];
              }
            } else if (item.properties && item.properties['Gift Wrapping']) {
              // Use existing property if checkbox element not found
              properties['Gift Wrapping'] = item.properties['Gift Wrapping'];
            }

            // Only update items that have actual customizations (gift message, engraving, or gift wrapping)
            // Check if there are customization properties that need to be saved
            const hasGiftMessage = properties['Gift Message'] && properties['Gift Message'] !== '';
            const hasEngraving = properties['Engraving'] && properties['Engraving'] !== '';
            const hasGiftWrapping = properties['Gift Wrapping'] && properties['Gift Wrapping'] !== '';
            const hasCustomizations = hasGiftMessage || hasEngraving || hasGiftWrapping;

            // Update items that have customizations to ensure properties are saved to cart
            // This ensures all customizations persist through checkout for admin visibility
            if (hasCustomizations && Object.keys(properties).length > 0) {
              // Shopify doesn't support updating properties on existing items
              // We need to remove and re-add the item with properties
              itemsToUpdate.push({
                variantId: item.variant_id,
                quantity: item.quantity,
                properties: properties,
                lineIndex: lineIndex,
                itemKey: itemKey,
                originalItem: item
              });
            }
          });

          // If no items need updating, proceed
          if (itemsToUpdate.length === 0) {
            return Promise.resolve(true);
          }

          // Update items sequentially to avoid conflicts
          return updateCartItemsWithProperties(itemsToUpdate);
        });
    }

    // Update cart items by removing and re-adding with properties
    function updateCartItemsWithProperties(itemsToUpdate) {
      // Sort items by line index in reverse order to avoid index shifting
      const sortedItems = itemsToUpdate.slice().sort(function(a, b) {
        return b.lineIndex - a.lineIndex;
      });

      // Step 1: Remove all items that need updating (in reverse order)
      return sortedItems.reduce(function(promise, itemData) {
        return promise.then(function() {
          return fetch('/cart/change.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded',
            },
            body: `id=${encodeURIComponent(itemData.itemKey || itemData.originalItem.key)}&quantity=0`
          })
          .then(function(response) {
            if (!response.ok) {
              return response.text().then(function(text) {
                console.error('Failed to remove item:', text);
                throw new Error('Failed to remove item: ' + response.status);
              });
            }
            return response.json();
          });
        });
      }, Promise.resolve())
      .then(function() {
        // Step 2: Re-add all items with properties in one batch request
        const itemsToAdd = sortedItems.reverse().map(function(itemData) {
          return {
            id: itemData.variantId,
            quantity: itemData.quantity,
            properties: itemData.properties
          };
        });

        return fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({
            items: itemsToAdd
          })
        })
        .then(function(response) {
          if (!response.ok) {
            return response.text().then(function(text) {
              console.error('Failed to add items with properties:', text);
              throw new Error('Failed to add items with properties: ' + response.status);
            });
          }
          return response.json();
        });
      })
      .then(function() {
        // Verify the cart was updated correctly
        return fetch('/cart.js', {
          headers: { Accept: 'application/json' }
        })
        .then(function(response) {
          if (!response.ok) {
            throw new Error('Failed to verify cart update');
          }
          return response.json();
        })
        .then(function(cart) {
          // Verify all properties were saved
          let allSaved = true;
          itemsToUpdate.forEach(function(itemData) {
            const cartItem = cart.items.find(function(item) {
              return item.variant_id === itemData.variantId && 
                     item.quantity === itemData.quantity &&
                     item.properties && 
                     Object.keys(item.properties).length > 0;
            });
            if (!cartItem) {
              allSaved = false;
            }
          });
          return allSaved;
        });
      })
      .catch(function(error) {
        console.error('Error updating cart items with properties:', error);
        return false; // Return false to indicate failure
      });
    }

    // Initialize add another and wishlist buttons
    initAddAnotherButtons();
    initWishlistButtons();
    initGiftWrappingAccordions();
    initGiftMessageModal();
    initEngravingModal();
    initCheckoutInterception();

    // Listen for cart updates from other parts of the site
    window.addEventListener('cart:updated', function (event) {
      if (event.detail) {
        // Update cart summary
        updateCartSummaryDisplay(event.detail.total_price || 0, event.detail.total_tax || event.detail.tax_price || 0);

        // Update all prices directly from server (most accurate)
        if (typeof updatePricesFromCart === 'function') {
          updatePricesFromCart(event.detail);
        }

        // Update button states
        if (typeof quantityInputs !== 'undefined' && typeof updateQuantityButtons === 'function') {
          quantityInputs.forEach(function (input) {
            updateQuantityButtons(input);
          });
        }
      }
    });

    // Also listen for cart refresh events
    window.addEventListener('cart:refresh', function () {
      fetchCartState().then(function (cart) {
        if (cart) {
          // Update cart summary
          updateCartSummaryDisplay(cart.total_price || 0, cart.total_tax || cart.tax_price || 0);

          // Update all prices directly from server
          if (typeof updatePricesFromCart === 'function') {
            updatePricesFromCart(cart);
          }

          // Update button states
          if (typeof quantityInputs !== 'undefined' && typeof updateQuantityButtons === 'function') {
            quantityInputs.forEach(function (input) {
              updateQuantityButtons(input);
            });
          }
        }
      });
    });

    // Listen for wishlist updates
    document.addEventListener('wishlist:updated', function() {
      initWishlistButtons();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-content"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    // Handle FAQ question toggles with accordion behavior
    const toggles = document.querySelectorAll('.faq-question__toggle');
    
    function closeFAQ(toggle) {
      const answer = toggle.nextElementSibling;
      const icon = toggle.querySelector('.faq-question__icon');
      
      toggle.setAttribute('aria-expanded', 'false');
      answer.hidden = true;
      icon.textContent = '+';
    }
    
    function openFAQ(toggle) {
      const answer = toggle.nextElementSibling;
      const icon = toggle.querySelector('.faq-question__icon');
      
      toggle.setAttribute('aria-expanded', 'true');
      answer.hidden = false;
      icon.textContent = '−';
    }
    
    function closeAllFAQs(currentToggle) {
      toggles.forEach(toggle => {
        if (toggle !== currentToggle) {
          closeFAQ(toggle);
        }
      });
    }
    
    toggles.forEach(toggle => {
      toggle.addEventListener('click', function() {
        const isExpanded = this.getAttribute('aria-expanded') === 'true';
        
        // Close all other FAQs when opening a new one
        if (!isExpanded) {
          closeAllFAQs(this);
          openFAQ(this);
        } else {
          closeFAQ(this);
        }
      });
    });

    // Handle category filtering with AJAX and URL updates
    const categoryButtons = document.querySelectorAll('.faq-category');
    const faqSections = document.querySelectorAll('.faq-section');
    const faqContent = document.querySelector('.faq-content');
    
    function switchCategory(index, categorySlug, updateUrl = true) {
      // Remove active class from all buttons
      categoryButtons.forEach(btn => btn.classList.remove('faq-category--active'));
      
      // Add active class to clicked button
      if (categoryButtons[index]) {
        categoryButtons[index].classList.add('faq-category--active');
      }
      
      // Add fade effect
      if (faqContent) {
        faqContent.style.opacity = '0.5';
      }
      
      // Use setTimeout to create smooth transition
      setTimeout(() => {
        // Hide all sections
        faqSections.forEach(section => {
          section.hidden = true;
        });
        
        // Show the selected category section
        const targetSection = document.querySelector(`[data-category="${index}"]`);
        if (targetSection) {
          targetSection.hidden = false;
          
          // Restore opacity
          if (faqContent) {
            faqContent.style.opacity = '1';
          }
          
          // Scroll to content area smoothly
          targetSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }, 150);
      
      // Update URL with query parameter
      if (updateUrl && categorySlug) {
        const url = new URL(window.location);
        url.searchParams.set('category', categorySlug);
        window.history.pushState({ category: categorySlug, index: index }, '', url);
      }
    }
    
    categoryButtons.forEach((button, index) => {
      button.addEventListener('click', function(e) {
        e.preventDefault();
        const categorySlug = this.getAttribute('data-category-slug');
        switchCategory(index, categorySlug, true);
      });
    });
    
    // Handle browser back/forward buttons
    window.addEventListener('popstate', function(event) {
      if (event.state && event.state.category) {
        const button = document.querySelector(`[data-category-slug="${event.state.category}"]`);
        if (button) {
          const index = parseInt(button.getAttribute('data-category-index'));
          switchCategory(index, event.state.category, false);
        }
      } else {
        // Default to first category
        switchCategory(0, categoryButtons[0]?.getAttribute('data-category-slug'), false);
      }
    });
    
    // Check URL on page load
    const urlParams = new URLSearchParams(window.location.search);
    const categoryParam = urlParams.get('category');
    
    if (categoryParam) {
      const button = document.querySelector(`[data-category-slug="${categoryParam}"]`);
      if (button) {
        const index = parseInt(button.getAttribute('data-category-index'));
        switchCategory(index, categoryParam, false);
      }
    } else {
      // Set initial URL state
      const firstSlug = categoryButtons[0]?.getAttribute('data-category-slug');
      if (firstSlug) {
        const url = new URL(window.location);
        url.searchParams.set('category', firstSlug);
        window.history.replaceState({ category: firstSlug, index: 0 }, '', url);
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["how-to-guide"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const tabs = document.querySelectorAll('.how-to-guide__tab');
    const categories = document.querySelectorAll('.how-to-guide__category');
    const content = document.querySelector('.how-to-guide__content');
    
    function switchCategory(category) {
      // Update tabs
      tabs.forEach(tab => {
        const isActive = tab.getAttribute('data-category') === category;
        tab.classList.toggle('how-to-guide__tab--active', isActive);
        tab.setAttribute('aria-selected', isActive);
      });
      
      // Update content
      if (content) {
        content.style.opacity = '0.5';
      }
      
      setTimeout(() => {
        categories.forEach(cat => {
          cat.hidden = cat.getAttribute('data-category') !== category;
        });
        
        if (content) {
          content.style.opacity = '1';
        }
      }, 150);
    }
    
    tabs.forEach(tab => {
      tab.addEventListener('click', function() {
        const category = this.getAttribute('data-category');
        switchCategory(category);
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jewelry-care-content"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const tabs = document.querySelectorAll('.jewelry-care-nav__tab');
    const materials = document.querySelectorAll('.jewelry-care-material');
    const categoryHeading = document.getElementById('category-heading');
    
    const categoryLabels = {
      'all': 'ALL MATERIALS',
      'metals': 'METALS',
      'stones': 'STONES AND OTHERS',
      'other': 'OTHER MATERIALS'
    };
    
    function filterMaterials(category) {
      materials.forEach(material => {
        const materialCategory = material.getAttribute('data-category');
        if (category === 'all' || materialCategory === category) {
          material.style.display = '';
        } else {
          material.style.display = 'none';
        }
      });
      
      if (categoryHeading) {
        categoryHeading.textContent = categoryLabels[category];
      }
    }
    
    tabs.forEach(tab => {
      tab.addEventListener('click', function() {
        tabs.forEach(t => {
          t.classList.remove('jewelry-care-nav__tab--active');
          t.setAttribute('aria-selected', 'false');
        });
        this.classList.add('jewelry-care-nav__tab--active');
        this.setAttribute('aria-selected', 'true');
        
        const category = this.getAttribute('data-category');
        filterMaterials(category);
      });
    });
    
    filterMaterials('all');
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const NEWSLETTER_STORAGE_KEY = 'newsletterSubscribed';
    const formWrapper = document.getElementById('newsletter-form-wrapper');
    const subscribedMessage = document.getElementById('newsletter-subscribed');
    const successBox = document.getElementById('newsletter-success-box');
    const form = document.querySelector('.newsletter-section__form');

    // Check if user is already subscribed
    function isSubscribed() {
      return localStorage.getItem(NEWSLETTER_STORAGE_KEY) === 'true';
    }

    // Mark user as subscribed
    function markAsSubscribed() {
      localStorage.setItem(NEWSLETTER_STORAGE_KEY, 'true');
    }

    // Show subscribed message (simple text)
    function showSubscribedMessage() {
      if (formWrapper) formWrapper.style.display = 'none';
      if (subscribedMessage) subscribedMessage.style.display = 'flex';
    }

    // Check if URL has customer_posted=true (form submission success)
    const urlParams = new URLSearchParams(window.location.search);
    const customerPosted = urlParams.get('customer_posted') === 'true';

    // If form was just submitted successfully, mark as subscribed
    if (customerPosted && successBox) {
      markAsSubscribed();
      // Green success box is already showing via Liquid
    }
    // If already subscribed (from localStorage), show simple message
    else if (isSubscribed()) {
      showSubscribedMessage();
    }

    // Handle form submission
    if (form) {
      form.addEventListener('submit', function(e) {
        // Mark as subscribed when form is submitted
        markAsSubscribed();
        
        // Let the form submit naturally to Shopify
        // After page reload with customer_posted=true, green box will show
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ring-sizing-info"] && !Shopify.designMode) return;
  try {
    
(function() {
  const accordions = document.querySelectorAll('.ring-sizing-info__accordion');
  
  accordions.forEach(accordion => {
    const button = accordion.querySelector('.ring-sizing-info__accordion-button');
    const content = accordion.querySelector('.ring-sizing-info__accordion-content');
    
    if (!button || !content) return;
    
    button.addEventListener('click', function() {
      const isExpanded = this.getAttribute('aria-expanded') === 'true';
      
      // Close all other accordions
      accordions.forEach(otherAccordion => {
        if (otherAccordion !== accordion) {
          const otherButton = otherAccordion.querySelector('.ring-sizing-info__accordion-button');
          const otherContent = otherAccordion.querySelector('.ring-sizing-info__accordion-content');
          if (otherButton && otherContent) {
            otherButton.setAttribute('aria-expanded', 'false');
            otherButton.classList.remove('ring-sizing-info__accordion-button--active');
            otherContent.style.maxHeight = null;
          }
        }
      });
      
      // Toggle current accordion
      this.setAttribute('aria-expanded', !isExpanded);
      this.classList.toggle('ring-sizing-info__accordion-button--active');
      
      if (!isExpanded) {
        content.style.maxHeight = content.scrollHeight + 'px';
      } else {
        content.style.maxHeight = null;
      }
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sizing-video"] && !Shopify.designMode) return;
  try {
    
(function() {
  const videoSection = document.querySelector('.sizing-video');
  if (!videoSection) return;

  const video = videoSection.querySelector('.sizing-video__player');
  const pauseBtn = videoSection.querySelector('.sizing-video__pause-btn');
  const wrapper = videoSection.querySelector('.sizing-video__wrapper');

  if (!video || !pauseBtn || !wrapper) return;

  // Initialize wrapper state
  wrapper.classList.add('playing');

  // Pause button click handler
  pauseBtn.addEventListener('click', function() {
    if (video.paused) {
      video.play();
      wrapper.classList.remove('paused');
      wrapper.classList.add('playing');
    } else {
      video.pause();
      wrapper.classList.remove('playing');
      wrapper.classList.add('paused');
    }
  });

  // Update button state based on video state
  video.addEventListener('play', function() {
    wrapper.classList.remove('paused');
    wrapper.classList.add('playing');
  });

  video.addEventListener('pause', function() {
    wrapper.classList.remove('playing');
    wrapper.classList.add('paused');
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["terms-conditions"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const navLinks = document.querySelectorAll('.terms-page__nav-link');
    const categories = document.querySelectorAll('.terms-category');
    const toggles = document.querySelectorAll('.terms-accordion__toggle');

    function setActiveLink(hash) {
      navLinks.forEach(link => {
        if (link.getAttribute('href') === hash) {
          link.classList.add('is-active');
          link.setAttribute('aria-current', 'true');
        } else {
          link.classList.remove('is-active');
          link.removeAttribute('aria-current');
        }
      });
    }

    function showCategory(targetId, shouldScroll = true) {
      categories.forEach(category => {
        const isTarget = `#${category.id}` === targetId;
        category.hidden = !isTarget;
        category.classList.toggle('is-visible', isTarget);
      });
      setActiveLink(targetId);
      if (shouldScroll) {
        const targetHeading = document.querySelector(`${targetId} .terms-category__title`);
        if (targetHeading) {
          targetHeading.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }
    }

    if (navLinks.length && categories.length) {
      showCategory(navLinks[0].getAttribute('href'), false);
    }

    navLinks.forEach(link => {
      link.addEventListener('click', function(event) {
        event.preventDefault();
        const targetId = this.getAttribute('href');
        showCategory(targetId);
      });
    });

    function closePanel(toggle) {
      const panel = toggle.nextElementSibling;
      const icon = toggle.querySelector('.terms-accordion__icon');
      toggle.setAttribute('aria-expanded', 'false');
      panel.hidden = true;
      icon.textContent = '+';
    }

    function openPanel(toggle) {
      const panel = toggle.nextElementSibling;
      const icon = toggle.querySelector('.terms-accordion__icon');
      toggle.setAttribute('aria-expanded', 'true');
      panel.hidden = false;
      icon.textContent = '−';
    }

    toggles.forEach(toggle => {
      toggle.addEventListener('click', function() {
        const isExpanded = this.getAttribute('aria-expanded') === 'true';
        toggles.forEach(other => {
          if (other !== this) {
            closePanel(other);
          }
        });
        if (isExpanded) {
          closePanel(this);
        } else {
          openPanel(this);
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["welcome-card"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const STORAGE_KEY = 'welcomeCardShown';
    const NEWSLETTER_STORAGE_KEY = 'newsletterSubscribed';
    const overlay = document.getElementById('welcome-card-overlay');
    
    if (!overlay) {
      console.error('Welcome card overlay not found');
      return;
    }
    
    const closeBtn = overlay.querySelector('.welcome-card-close');
    const form = document.getElementById('welcome-email-form');

    // Check if welcome card has been shown before OR user is subscribed
    function hasSeenWelcomeCard() {
      return localStorage.getItem(STORAGE_KEY) === 'true' || localStorage.getItem(NEWSLETTER_STORAGE_KEY) === 'true';
    }

    // Mark welcome card as shown
    function markWelcomeCardShown() {
      localStorage.setItem(STORAGE_KEY, 'true');
    }

    // Mark user as subscribed
    function markAsSubscribed() {
      localStorage.setItem(NEWSLETTER_STORAGE_KEY, 'true');
    }

    // Show welcome card
    function showWelcomeCard() {
      overlay.style.display = 'flex';
      document.body.style.overflow = 'hidden';
    }

    // Hide welcome card
    function hideWelcomeCard() {
      overlay.style.display = 'none';
      document.body.style.overflow = '';
      markWelcomeCardShown();
    }

    // Close button handler
    closeBtn.addEventListener('click', hideWelcomeCard);

    // Close on overlay click
    overlay.addEventListener('click', function(e) {
      if (e.target === overlay) {
        hideWelcomeCard();
      }
    });

    // Close on ESC key
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && overlay.style.display === 'flex') {
        hideWelcomeCard();
      }
    });

    // Form submission handler
    if (form) {
      form.addEventListener('submit', function(e) {
        e.preventDefault();
        const mainContent = document.getElementById('welcome-card-main');
        const successContent = document.getElementById('welcome-card-success');
        
        // Show loading state
        const submitBtn = form.querySelector('button[type="submit"]');
        const originalText = submitBtn.textContent;
        submitBtn.textContent = 'SUBSCRIBING...';
        submitBtn.disabled = true;
        
        // Get form data
        const formData = new FormData(form);
        
        // Mark as subscribed immediately
        markAsSubscribed();
        
        // Submit to Shopify
        fetch(form.action, {
          method: 'POST',
          body: formData
        })
        .then(function(response) {
          // Show success message
          mainContent.style.display = 'none';
          successContent.style.display = 'flex';
          
          // Auto-close after 3 seconds
          setTimeout(function() {
            hideWelcomeCard();
          }, 3000);
        })
        .catch(function(error) {
          console.error('Subscription error:', error);
          // Still show success for better UX
          mainContent.style.display = 'none';
          successContent.style.display = 'flex';
          
          setTimeout(function() {
            hideWelcomeCard();
          }, 3000);
        });
      });
    }

    // Show card if first visit
    if (!hasSeenWelcomeCard()) {
      // Small delay for better UX
      setTimeout(showWelcomeCard, 800);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["z-workshop"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const observerOptions = {
      threshold: 0.15,
      rootMargin: '0px 0px -10% 0px'
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('z-workshop__row--visible');
          observer.unobserve(entry.target);
        }
      });
    }, observerOptions);

    document.querySelectorAll('.z-workshop__row').forEach(row => {
      observer.observe(row);
    });
  });

  } catch(e) { console.error(e); }
})();
})();
